import _Number$isNaN from 'babel-runtime/core-js/number/is-nan';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _isNil from 'lodash/isNil';
/* eslint-disable no-underscore-dangle */
import React, { PureComponent, Children } from 'react';
import PropTypes from 'prop-types';

import * as style from './Scrollable.style';

var Scrollable = function (_PureComponent) {
  _inherits(Scrollable, _PureComponent);

  function Scrollable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scrollable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scrollable.__proto__ || _Object$getPrototypeOf(Scrollable)).call.apply(_ref, [this].concat(args))), _this), _this.scrollTo = function (offset) {
      if (_Number$isNaN(Number(offset)) || !_this._outerContainerRef || !_this._innerContainerRef) {
        return;
      }
      var nextOffset = Math.max(0, Math.min(_this.innerWidth - _this.outerWidth, Number(offset)));
      var delta = nextOffset - _this._outerContainerRef.scrollLeft;
      if (delta === 0) return;
      var onTransitionEnd = function onTransitionEnd() {
        _this._innerContainerRef.removeEventListener('transitionend', onTransitionEnd);
        _this._innerContainerRef.style.setProperty('transition', '');
        _this._innerContainerRef.style.setProperty('transform', '');
        _this._outerContainerRef.scrollLeft = nextOffset;
      };
      _this._innerContainerRef.addEventListener('transitionend', onTransitionEnd);
      _this._innerContainerRef.style.setProperty('transition', 'transform 0.5s ease-in-out');
      _this._innerContainerRef.style.setProperty('transform', 'translateX(' + -delta + 'px)');
    }, _this._onScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      }
    }, _this._setOuterContainerRef = function (el) {
      _this._outerContainerRef = el;
    }, _this._setInnerContainerRef = function (el) {
      _this._innerContainerRef = el;
    }, _this._outerContainerRef = null, _this._innerContainerRef = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Scrollable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._outerContainerRef.addEventListener('scroll', this._onScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._outerContainerRef.removeEventListener('scroll', this._onScroll);
    }

    // eslint-disable-next-line complexity

  }, {
    key: 'render',
    value: function render() {
      var items = this.props.children;

      return React.createElement(
        'div',
        { className: style.container, ref: this._setOuterContainerRef },
        React.createElement(
          'ul',
          { className: style.content, ref: this._setInnerContainerRef },
          Children.map(items, function (child) {
            return React.createElement(
              'li',
              { className: style.item },
              child
            );
          })
        )
      );
    }
  }, {
    key: 'overflow',
    get: function get() {
      var scroll = this.innerWidth > this.outerWidth;
      var left = scroll && this.scrollLeft > 0;
      var right = scroll && this.scrollLeft < this.innerWidth - this.outerWidth;
      if (left && right) {
        return 'both';
      }
      if (left) {
        return 'left';
      }
      if (right) {
        return 'right';
      }
      return 'none';
    }
  }, {
    key: 'innerWidth',
    get: function get() {
      return _isNil(this._innerContainerRef) ? 0 : this._innerContainerRef.clientWidth;
    }
  }, {
    key: 'outerWidth',
    get: function get() {
      return _isNil(this._outerContainerRef) ? 0 : this._outerContainerRef.clientWidth;
    }
  }, {
    key: 'scrollLeft',
    get: function get() {
      return _isNil(this._outerContainerRef) ? 0 : this._outerContainerRef.scrollLeft;
    },
    set: function set(scrollLeft) {
      if (_isNil(this._outerContainerRef)) return;
      this._outerContainerRef.scrollLeft = Math.max(0, Math.min(this.innerWidth - this.outerWidth, Number(scrollLeft)));
    }
  }]);

  return Scrollable;
}(PureComponent);

Scrollable.propTypes = {
  children: PropTypes.node,
  onScroll: PropTypes.func
};
export default Scrollable;